export const categories = [
  {
    id: 'beauty',
    name: '美妆护肤',
    icon: 'ri-magic-line',
    description: '日本殿堂级美妆护肤品牌，从平价药妆到高端专柜，应有尽有',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20skincare%20and%20cosmetics%20products%20arranged%20on%20a%20clean%20minimal%20wooden%20surface%20with%20soft%20natural%20lighting%2C%20elegant%20product%20photography%2C%20warm%20cream%20background%2C%20high%20quality%20editorial%20style&width=800&height=600&seq=cat-beauty-01&orientation=landscape',
  },
  {
    id: 'food',
    name: '食品零食',
    icon: 'ri-cake-line',
    description: '地道日本零食、调味料、茶饮，带您品味原汁原味的日本味道',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20snacks%20and%20food%20items%20beautifully%20arranged%20on%20a%20warm%20wooden%20table%2C%20matcha%20sweets%2C%20rice%20crackers%2C%20traditional%20packaging%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20aesthetic%2C%20food%20photography&width=800&height=600&seq=cat-food-01&orientation=landscape',
  },
  {
    id: 'home',
    name: '家居日用',
    icon: 'ri-home-heart-line',
    description: '日本匠心家居用品，简约实用设计，提升日常生活品质',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20home%20goods%20and%20kitchenware%20displayed%20on%20a%20minimal%20wooden%20shelf%2C%20ceramic%20teacups%2C%20linen%20towels%2C%20bamboo%20baskets%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%20photography&width=800&height=600&seq=cat-home-01&orientation=landscape',
  },
  {
    id: 'health',
    name: '健康保健',
    icon: 'ri-heart-pulse-line',
    description: '日本知名健康保健品，从维生素到功能性食品，守护全家健康',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20health%20supplements%20and%20wellness%20products%20on%20a%20clean%20minimal%20surface%2C%20vitamins%2C%20herbal%20remedies%2C%20natural%20packaging%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20editorial%20product%20photography&width=800&height=600&seq=cat-health-01&orientation=landscape',
  },
  {
    id: 'fashion',
    name: '服饰配饰',
    icon: 'ri-t-shirt-line',
    description: '日系潮流服饰与精致配饰，演绎简约而不简单的穿搭美学',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20fashion%20accessories%20and%20clothing%20items%20elegantly%20displayed%20on%20a%20minimal%20wooden%20surface%2C%20silk%20scarves%2C%20minimal%20jewelry%2C%20linen%20fabric%2C%20warm%20neutral%20background%2C%20soft%20natural%20lighting&width=800&height=600&seq=cat-fashion-01&orientation=landscape',
  },
  {
    id: 'baby',
    name: '母婴用品',
    icon: 'ri-bear-smile-line',
    description: '日本妈妈信赖的母婴品牌，安心安全的育婴好物',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20baby%20and%20maternity%20products%20arranged%20on%20a%20soft%20cream%20surface%2C%20organic%20baby%20clothes%2C%20natural%20skincare%2C%20wooden%20toys%2C%20gentle%20warm%20lighting%2C%20minimal%20aesthetic%20product%20photography&width=800&height=600&seq=cat-baby-01&orientation=landscape',
  },
  {
    id: 'digital',
    name: '数码电器',
    icon: 'ri-computer-line',
    description: '日本前沿数码产品与小家电，科技让生活更便捷',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20electronics%20and%20digital%20gadgets%20on%20a%20clean%20minimal%20desk%2C%20headphones%2C%20cameras%2C%20small%20appliances%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography&width=800&height=600&seq=cat-digital-01&orientation=landscape',
  },
];

export const products = [
  {
    id: 1,
    name: '资生堂红妍肌活精华露 50ml',
    categoryId: 'beauty',
    description: '日本资生堂明星产品，红腰子精华，提升肌肤免疫力，焕活年轻光采',
    price: '¥680',
    image: 'https://readdy.ai/api/search-image?query=Shiseido%20Ultimune%20Power%20Infusing%20Concentrate%20bottle%20on%20a%20clean%20minimal%20surface%2C%20red%20gradient%20bottle%2C%20luxury%20skincare%20product%20photography%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting&width=600&height=600&seq=prod-001&orientation=squarish',
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    name: 'SK-II 神仙水 230ml',
    categoryId: 'beauty',
    description: '日本SK-II经典护肤精华露，含超过90%天然活酵母精华PITERA™',
    price: '¥1,370',
    image: 'https://readdy.ai/api/search-image?query=SK-II%20Facial%20Treatment%20Essence%20bottle%20on%20a%20minimal%20surface%2C%20iconic%20glass%20bottle%2C%20luxury%20Japanese%20skincare%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography&width=600&height=600&seq=prod-002&orientation=squarish',
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    name: 'CPB肌肤之钥 光采洁面膏 125g',
    categoryId: 'beauty',
    description: 'Clé de Peau Beauté高端洁面，绵密泡沫温和清洁，洗后不紧绷',
    price: '¥450',
    image: 'https://readdy.ai/api/search-image?query=Cle%20de%20Peau%20Beaute%20cleansing%20foam%20tube%20on%20a%20minimal%20surface%2C%20luxury%20Japanese%20skincare%2C%20elegant%20packaging%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20high%20quality%20product%20photography&width=600&height=600&seq=prod-003&orientation=squarish',
    isHot: false,
    isNew: true,
  },
  {
    id: 4,
    name: '白色恋人 巧克力夹心饼干 24枚',
    categoryId: 'food',
    description: '北海道经典伴手礼，酥脆饼干夹心白巧克力，入口即化',
    price: '¥168',
    image: 'https://readdy.ai/api/search-image?query=Shiroi%20Koibito%20white%20chocolate%20sandwich%20cookies%20in%20elegant%20blue%20box%2C%20Japanese%20Hokkaido%20souvenir%2C%20on%20a%20clean%20minimal%20surface%2C%20warm%20cream%20background%2C%20food%20photography&width=600&height=600&seq=prod-004&orientation=squarish',
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    name: '一兰拉面 豚骨拉面 5食入',
    categoryId: 'food',
    description: '福冈著名拉面店一兰出品，浓郁豚骨汤底搭配秘制辣酱',
    price: '¥198',
    image: 'https://readdy.ai/api/search-image?query=Ichiran%20ramen%20instant%20noodles%20box%20set%20on%20a%20minimal%20surface%2C%20Japanese%20tonkotsu%20ramen%20kit%2C%20red%20and%20black%20packaging%2C%20warm%20cream%20background%2C%20clean%20food%20product%20photography&width=600&height=600&seq=prod-005&orientation=squarish',
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    name: 'ROYCE 生巧克力 原味 20粒',
    categoryId: 'food',
    description: '北海道ROYCE经典生巧克力，丝滑细腻入口即化，北海道鲜奶油制作',
    price: '¥138',
    image: 'https://readdy.ai/api/search-image?query=ROYCE%20Nama%20Chocolate%20box%20on%20a%20minimal%20surface%2C%20Japanese%20Hokkaido%20luxury%20chocolate%2C%20elegant%20packaging%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20food%20photography&width=600&height=600&seq=prod-006&orientation=squarish',
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    name: '象印 不锈钢保温杯 480ml',
    categoryId: 'home',
    description: '日本象印经典保温杯，超强保温保冷效果，轻巧便携设计',
    price: '¥259',
    image: 'https://readdy.ai/api/search-image?query=Zojirushi%20stainless%20steel%20vacuum%20insulated%20mug%20on%20a%20minimal%20surface%2C%20sleek%20Japanese%20design%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography&width=600&height=600&seq=prod-007&orientation=squarish',
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    name: '无印良品 超声波香薰机',
    categoryId: 'home',
    description: 'MUJI经典款香薰机，超声波雾化技术，营造舒适居家氛围',
    price: '¥380',
    image: 'https://readdy.ai/api/search-image?query=MUJI%20ultrasonic%20aroma%20diffuser%20on%20a%20minimal%20wooden%20surface%2C%20soft%20warm%20light%2C%20Japanese%20minimalist%20design%2C%20cream%20background%2C%20lifestyle%20product%20photography&width=600&height=600&seq=prod-008&orientation=squarish',
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    name: 'FANCL 综合维生素 30日分',
    categoryId: 'health',
    description: '日本FANCL无添加综合维生素，每日一包满足基础营养需求',
    price: '¥168',
    image: 'https://readdy.ai/api/search-image?query=FANCL%20multivitamin%20supplement%20packets%20on%20a%20clean%20minimal%20surface%2C%20Japanese%20health%20supplement%2C%20white%20and%20green%20packaging%2C%20warm%20cream%20background%2C%20soft%20lighting&width=600&height=600&seq=prod-009&orientation=squarish',
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    name: 'DHC 薏仁精华丸 20日分',
    categoryId: 'health',
    description: '日本DHC薏仁精华，帮助排除体内多余水分，美容养颜',
    price: '¥89',
    image: 'https://readdy.ai/api/search-image?query=DHC%20hatomugi%20supplement%20packets%20on%20a%20minimal%20surface%2C%20Japanese%20beauty%20supplement%2C%20green%20and%20white%20packaging%2C%20warm%20cream%20background%2C%20product%20photography&width=600&height=600&seq=prod-010&orientation=squarish',
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    name: 'UNIQLO 轻薄羽绒服 女士',
    categoryId: 'fashion',
    description: '优衣库经典轻薄羽绒系列，超轻保暖，可收纳设计便于携带',
    price: '¥499',
    image: 'https://readdy.ai/api/search-image?query=UNIQLO%20ultra%20light%20down%20jacket%20folded%20on%20a%20minimal%20surface%2C%20Japanese%20minimalist%20fashion%2C%20beige%20color%2C%20warm%20cream%20background%2C%20clean%20product%20photography&width=600&height=600&seq=prod-011&orientation=squarish',
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    name: '贝亲 宽口径玻璃奶瓶 240ml',
    categoryId: 'baby',
    description: '日本贝亲经典奶瓶，母乳实感奶嘴，防胀气设计，宝宝安心',
    price: '¥129',
    image: 'https://readdy.ai/api/search-image?query=Pigeon%20wide%20neck%20glass%20baby%20bottle%20on%20a%20soft%20minimal%20surface%2C%20Japanese%20baby%20product%2C%20warm%20cream%20background%2C%20gentle%20lighting%2C%20clean%20product%20photography&width=600&height=600&seq=prod-012&orientation=squarish',
    isHot: false,
    isNew: true,
  },
  {
    id: 13,
    name: '索尼 WH-1000XM5 无线降噪耳机',
    categoryId: 'digital',
    description: '索尼旗舰级无线降噪耳机，行业领先降噪技术，极致音质体验',
    price: '¥2,499',
    image: 'https://readdy.ai/api/search-image?query=Sony%20WH-1000XM5%20wireless%20noise%20cancelling%20headphones%20on%20a%20minimal%20surface%2C%20sleek%20design%2C%20Japanese%20electronics%2C%20warm%20cream%20background%2C%20professional%20product%20photography&width=600&height=600&seq=prod-013&orientation=squarish',
    isHot: true,
    isNew: false,
  },
  {
    id: 14,
    name: '黛珂 牛油果乳液 150ml',
    categoryId: 'beauty',
    description: 'COSME DECORTE经典先乳后水系列，深层滋润修复肌肤屏障',
    price: '¥520',
    image: 'https://readdy.ai/api/search-image?query=Decorte%20Phytotune%20softening%20emulsion%20bottle%20on%20a%20minimal%20surface%2C%20Japanese%20luxury%20skincare%2C%20elegant%20design%2C%20warm%20cream%20background%2C%20soft%20lighting&width=600&height=600&seq=prod-014&orientation=squarish',
    isHot: false,
    isNew: false,
  },
  {
    id: 15,
    name: '卡乐比 水果麦片 800g',
    categoryId: 'food',
    description: '日本国民麦片品牌，丰富水果谷物搭配，早餐营养便捷之选',
    price: '¥89',
    image: 'https://readdy.ai/api/search-image?query=Calbee%20fruit%20granola%20cereal%20bag%20on%20a%20minimal%20surface%2C%20Japanese%20breakfast%20cereal%2C%20colorful%20packaging%2C%20warm%20cream%20background%2C%20food%20product%20photography&width=600&height=600&seq=prod-015&orientation=squarish',
    isHot: true,
    isNew: false,
  },
  {
    id: 16,
    name: '虎牌 电饭煲 JKT-A10C',
    categoryId: 'home',
    description: '日本虎牌IH电饭煲，远红外内胆，煮出地道日式米饭口感',
    price: '¥2,680',
    image: 'https://readdy.ai/api/search-image?query=Tiger%20IH%20rice%20cooker%20on%20a%20minimal%20kitchen%20surface%2C%20Japanese%20kitchen%20appliance%2C%20sleek%20design%2C%20warm%20cream%20background%2C%20clean%20product%20photography&width=600&height=600&seq=prod-016&orientation=squarish',
    isHot: false,
    isNew: false,
  },
];

export const faqs = [
  {
    question: '岛国精品的商品都是日本原装正品吗？',
    answer: '是的，岛国精品所有商品均为日本原装进口正品。我们与超过200家日本品牌建立了直接合作关系，每一件商品都拥有完整的进口报关手续和品牌授权书。我们承诺假一赔十，让您购物无忧。',
  },
  {
    question: '下单后多久可以收到商品？',
    answer: '根据您的收货地址和商品库存情况，一般情况下：保税仓发货的商品约3-7个工作日送达；日本直邮商品约7-15个工作日送达。具体时效可在下单时查看商品详情页的预计送达时间。',
  },
  {
    question: '如何查询物流信息？',
    answer: '您可以在"我的订单"页面查看订单详情和物流追踪信息。商品发货后，系统会自动发送物流单号至您的注册邮箱和手机短信，方便您随时追踪包裹动态。',
  },
  {
    question: '支持哪些支付方式？',
    answer: '我们支持多种支付方式：支付宝、微信支付、银联卡、信用卡（Visa/Mastercard）以及花呗分期。所有支付均经过加密处理，确保您的支付信息安全。',
  },
  {
    question: '如果收到的商品有问题怎么办？',
    answer: '我们提供7天无理由退换货服务（需保持商品原包装完好）。如收到商品存在质量问题，请在签收后24小时内联系客服并提供相关照片，我们将在核实后第一时间为您处理退换货事宜。',
  },
  {
    question: '如何成为岛国精品的会员？',
    answer: '注册即成为岛国精品会员，享受会员专属价格和积分权益。积分可在下次购物时抵扣现金，每消费1元可获得1积分，100积分可抵扣1元。会员等级越高，享受的优惠越多。',
  },
];